import { FC } from 'react';
import Image from 'next/image';
import imgMylers from 'assets/HomeMyler/mylers.webp';
import Link from 'next/link';
import Button from 'components/Button/BaseButton';
import styles from './MylerHome.module.scss';
import { navigationPaths } from 'data/constants';

const MylerHome: FC = () => {
  return (
    <div className={styles['mylerhome']}>
      <div className={styles['mylerhome__image']}>
        <Image
          src={imgMylers}
          alt="Discover MyLER"
          layout="fill"
          objectFit="cover"
        />
      </div>
      <div className={styles['mylerhome__content']}>
        <div className={styles['mylerhome__txt--1']}>
          You’re here because you love luxury travel
        </div>
        <div className={styles['mylerhome__txt--2']}>
          So, why not turn it into a career?
        </div>
        <div className={styles['mylerhome__txt--3']}>
          Utilising Little Emperors’ intuitive digital platforms, our
          Independent Travel Advisor programme, MyLER, lets you scale your
          travel business and earn income while working from anywhere, anytime.
        </div>
        <div className={styles['mylerhome__cta']}>
          <Link href={navigationPaths.INDEPENDENT_TRAVEL_AGENT}>
            <a>
              <Button variant={'primary-black'}>Learn more</Button>
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MylerHome;
